import { Injectable } from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Router} from '@angular/router';
import {filesUrl} from '../api-url';

@Injectable({
  providedIn: 'root'
})
export class FilesService {
  respMsg: any = {};
  constructor(private http: HttpClient, private router: Router) { }
  saveFileData(file) {
    this.http
      .post(`${filesUrl}/`,  file)
      .subscribe(response => {
        console.log('File Data Saved', response);
        this.respMsg = response;
        this.router.navigate(['/']);
      });
  }
  deleteFile(fileId) {
    this.http.delete(`${filesUrl}/` + fileId)
      .subscribe(response => {
        console.log('FILE DELETE RESPONSE', response);
        // this.respMsg = response;
        // this.router.navigate(['/app/edit/record/']);
      });
  }
  getFilesByPerson(id) {
    return this.http.get<any[]>(`${filesUrl}/` + id);
  }
}
